let marker_form = ( function( $ ) {

	let $form,
		anim_speed = 400,
		first_time = true;

	let _init = function() {
		$form = $( 'form#marker-form' );

		if ( $form.length > 0 ) {
			_init_form();
		}

		$form.on( 'submit_error', _form_submit_error_response );
		$form.on( 'submit_success', _form_submit_success_response );
	};

	let _init_form = function() {
		_setup_comments_show_handlers();
		_initial_comments_show();
		_setup_select2();
		_setup_submission();
		_setup_field_error_remove();
	};

	let _setup_field_error_remove = function () {
		let $select = $form.find( 'select#grade-select' );

		$select.on( 'select2:close', function(  ) {
			_remove_error( $select.closest( '.field-wrap' ).find( '.form-error' ) );
		} );

		$form.find( '.form-section .radio-buttons-wrapper input[type="radio"]' ).on( 'change', function() {
			_remove_error( $( this ).closest( '.field-wrap' ).find( '.form-error' ) );
		} );

		$form.find( 'textarea' ).on( 'input propertychange', function() {
			_remove_error( $( this ).closest( '.field-wrap' ).find( '.form-error' ) );
		} );
	};

	let _setup_submission = function() {
		$form.find( 'a#submit-marker-form' ).on( 'click', _submit );
	};

	let _submit = function( e ) {
		e.preventDefault();

		$form.loading();

		_post_data();
	};

	let _post_data = function() {
		let values = _get_field_values();

		let data = {
			action: 'crate_submit_mark',
			nonce: ScriptData.crate_marker_form_nonce,
			values: values,
			proposal_id: $form.data( 'proposal-id' )
		};

		$.post( ScriptData.ajaxurl, data, _post_data_response );
	};

	let _post_data_response = function( response ) {
		if ( response.success ) {
			$form.trigger( 'submit_success', response );
		} else {
			$form.trigger( 'submit_error', response );
		}
	};

	let _form_submit_error_response = function( e, response ) {
		$form.addClass( 'has-errors' );
		_output_errors( response.errors );
	};

	let _output_errors = function( errors ) {

		_remove_all_errors();

		$( 'html, body' ).animate( { scrollTop: $form.offset().top }, anim_speed );

		if ( errors.form ) {
			$form.find( '.content-box' ).first().prepend( _generate_error_html( errors.form ? errors.form : 'There has been an error submitting the issues have been highlighted bellow', 'top-error' ) );
		}

		$.each( errors.abstract, function( key, error ) {
			if ( error.comments || error.approval ) {
				$form.find( '.form-section[data-abstract-key="' + key + '"] .box' ).addClass( 'field-has-error' );
				$form.find( '.form-section[data-abstract-key="' + key + '"] .box-bottom .radio-buttons-wrapper' ).prepend( _generate_error_html( error.approval ) );
				$form.find( '.form-section[data-abstract-key="' + key + '"] .comments-box-wrapper' ).prepend( _generate_error_html( error.comments ) );
			}
		} );

		if ( errors.grade ) {
			$form.find( '#grade-section .field-wrap' ).first()
				.addClass( 'field-has-error' )
				.prepend( _generate_error_html( errors.grade ) );
		}

		if ( errors.general_comments ) {
			$form.find( '#grade-section .general-comments-section' ).first()
				.addClass( 'field-has-error' )
				.prepend( _generate_error_html( errors.general_comments ) );
		}

		setTimeout( function() {
			$form.find( '.form-error' ).fadeIn( anim_speed );
			$form.loaded();
		}, anim_speed )
	};

	let _generate_error_html = function( text, classes = '' ) {
		if ( text ) {
			return $( '<div class="form-error ' + classes + '" style="display: none">' + text + '</div>' );
		}
	};

	let _remove_error = function( $error ) {

		$error.closest( '.field-has-error' ).removeClass( 'field-has-error' );

		if ( $error.length > 0 ) {
			$error.slideUp( anim_speed );
			setTimeout( function() {
				$error.remove();
			}, anim_speed );
		}

		if ( $form.find( 'form-error' ).length === 0 ) {
			if( $form.find( 'form-error top-error' ).length > 0 ) {
				$form.removeClass( '.has-errors' );
				_remove_error( $form.find( 'form-error top-error' ) );
			}
		}
	};

	let _remove_all_errors = function() {
		$form.find( '.form-error' ).each( function( index, item ) {
			_remove_error( $( item ) );
		} )
	};

	let _form_submit_success_response = function( e, response ) {
		$form.loaded();

		window.location = $form.data( 'redirect' );
	};

	let _get_field_values = function() {
		return {
			abstract: _get_form_abstract_values(),
			grade: _get_form_grade(),
			general_comments: _get_form_general_comments(),
		};
	};

	let _get_form_abstract_values = function() {
		let $sections = $form.find( '#abstract-sections .form-section' );

		let values = {};

		$sections.each( function( index, section ) {
			let $section = $( section ),
				key      = $section.data( 'abstract-key' ),
				$checked = $section.find( 'input[type="radio"]:checked' );

			values[key] = {
				approval: $checked.length > 0 ? $checked.val() : '',
				comments: $section.find( 'textarea' ).val()
			}
		} );

		return values
	};

	let _get_form_general_comments = function() {
		return $form.find( 'textarea#general-comments' ).val();
	};

	let _get_form_grade = function() {
		return $form.find( 'select#grade-select' ).val();
	};

	let _setup_select2 = function() {
		let $select = $form.find( 'select#grade-select' );

		let $select2 = $select.select2( {
			dropdownParent : $select.closest( '.field-wrap' ),
		} );

		if ( $select.val() !== ' ' ) {
			_show_overall_comments( false );
		} else {
			_hide_overall_comments_box( false );
		}

		$select2.on( 'select2:select', function( e ) {

			if ( $select.val() ) {
				_show_overall_comments();
			} else {
				_hide_overall_comments_box( false );
			}
		} );

		_change_select_options();

		$form.find( '.form-section .radio-buttons-wrapper input[type="radio"]' ).on( 'change', function() {
			_change_select_options();
		} );
	};

	let _change_select_options = function() {
		let $select = $form.find( 'select#grade-select' );

		if ( _show_approved_select_option() ) {
			$select.find( 'option:not([value="accepted"])' ).attr( 'disabled', 'disabled' );
			$select.find( 'option[value="accepted"]' ).removeAttr( 'disabled' );
		} else {
			$select.find( 'option[value="accepted"]' ).attr( 'disabled', 'disabled' );
			$select.find( 'option:not([value="accepted"])' ).removeAttr( 'disabled' );
		}

		$select.val( '' );

		_hide_overall_comments_box( true );

		$select.select2( {
			dropdownParent : $select.closest( '.field-wrap' ),
		} );
	};

	let _show_approved_select_option = function() {
		let $checked_fields = $form.find( '.form-section .radio-buttons-wrapper input[type="radio"]:checked' ),
			all_approved = true;

		$checked_fields.each( function( index, item ) {
			let $input = $( item );

			if ( $input.val() === 'disapproved' ) {
				return all_approved = false;
			}
		} );

		return all_approved;
	};

	let _show_overall_comments = function( animate = true ) {
		let $box = $form.find( '#grade-section .general-comments-section' );

		if ( ! animate ) {
			$box.removeClass( 'not-shown' ).addClass( 'shown' ).slideDown();
		} else {
			$box.slideDown( anim_speed );

			setTimeout( function() {
				$box.removeClass( 'not-shown' );
				$box.addClass( 'shown' );
			}, anim_speed );
		}
	};

	let _hide_overall_comments_box = function( animate = true ) {
		let $box = $form.find( '#grade-section .general-comments-section' );

		if ( ! animate ) {
			$box.removeClass( 'shown' ).addClass( 'not-shown' );
		} else {
			$box.slideUp( anim_speed );

			setTimeout( function() {
				$box.removeClass( 'shown' );
				$box.addClass( 'not-shown' );
			}, anim_speed );
		}
	};

	let _initial_comments_show = function() {
		let $radio_buttons = $form.find( '.form-section .radio-buttons-wrapper input[type="radio"].disapprove' );

		$radio_buttons.trigger( 'change' );

		setTimeout( function() {
			first_time = false;
		}, anim_speed );
	};

	let _setup_comments_show_handlers = function() {
		let $radio_buttons = $form.find( '.form-section .radio-buttons-wrapper input[type="radio"]' );

		$radio_buttons.on( 'change', function() {
			let $input = $( this ),
				$box   = $input.closest( '.box' );

			if ( $input.is( ':checked' ) && $input.hasClass( 'approve' ) ) {
				_hide_comments_box( $box );

				$box.removeClass( 'field-has-error' );
			}

			if ( $input.is( ':checked' ) && $input.hasClass( 'disapprove' ) ) {
				if ( ! first_time ) {
					_show_comments_box( $box.closest( '.box' ) );
				} else  {
					_show_comments_box( $box, false );
				}
			}
		} );
	};

	let _show_comments_box = function( $box, animate = true ) {
		if ( ! animate ) {
			$box.find( '.comments-box-wrapper' ).removeClass( 'not-shown' ).addClass( 'shown' );
		} else {
			$box.find( '.comments-box-wrapper' ).removeClass( 'not-shown' ).slideDown( anim_speed );

			setTimeout( function() {
				$box.find( '.comments-box-wrapper' ).addClass( 'shown' );
			}, anim_speed );
		}
	};

	let _hide_comments_box = function ( $box, animate = true ) {
		if ( ! animate ) {
			$box.find( '.comments-box-wrapper' ).removeClass( 'shown' ).addClass( 'not-shown' );
		} else {
			$box.find( '.comments-box-wrapper' ).slideUp( anim_speed );

			setTimeout( function() {
				$box.find( '.comments-box-wrapper' ).removeClass( 'shown' );
				$box.find( '.comments-box-wrapper' ).addClass( 'not-shown' );
			}, anim_speed );
		}
	};

	$( document ).ready( _init );

	return {};

} )( jQuery );

module.exports = marker_form;